/// <amd-module name="Search/Code/Flux/Stores/ItemContentStore" />
import * as VSSStore from "VSS/Reflux/Store";
import { IItemChangedPayload } from "Search/Shared/Base/ActionsHub";
import { ISeedData } from "Search/Shared/Base/Types";
import { CodeResult } from "Search/LegacyWebApi/Contracts/Code";

export interface IItemContentStoreState {
    selectedItem: CodeResult;

    activatedOnPreviousNavigation?: boolean;
}

export class ItemContentStore extends VSSStore.Store {
    private _state = {} as IItemContentStoreState;

    constructor(changedEventName: string, data?: ISeedData<CodeResult>) {
        super(changedEventName);
        if (data && data.activeItem) {
            this._state.selectedItem = data.activeItem;
        }
    }

    public get state(): IItemContentStoreState {
        return this._state;
    }

    public changeActiveItem = (payload: IItemChangedPayload<CodeResult>): void => {
        this._state.selectedItem = payload.item;
        this._state.activatedOnPreviousNavigation = payload.activatedOnPreviousNavigation;
        this.emitChanged();
    };
}
